<template>
  <div class="container">
    <div class=" card-wrap">
      <div class="subtitle">
        <select-mu-wei ref="selectMuWei" />
      </div>
      <div class="goods-wrap">
        <van-swipe class="goods-wrap_left" :autoplay="3000" indicator-color="#1baeae">
          <van-swipe-item v-for="(item, index) in detail.commodityRotationChart" :key="index">
            <img @click="handlePreviewImg(index)" :src="item" alt="" style="width:95%;height:95%">
          </van-swipe-item>
        </van-swipe>
        <div class="goods-wrap_right">
          <div>{{ detail.tradeName }}</div>
          <div>价格：{{ detail.price }}</div>
          <div>{{ detail.productIntroduction }}</div>
        </div>
      </div>
      <!-- <div class="van-hairline--top">
        <span>数量</span>
        <van-stepper v-model="form.amount" />
      </div> -->
      <van-cell title="数量" v-show="+detail.id !== 0">
        <template>
          <van-stepper v-model="form.amount" />
        </template>
      </van-cell>
      <!-- <van-cell
        title="预约日期"
        is-link
        v-show="+detail.commodityClass === 1"
        :value="moment(form.requiredServiceTime).format('YYYY-MM-DD HH:mm')"
        @click="openTime"
      /> -->
    </div>
    <div class="card-wrap">
      <div class="card-wrap_top">
        <span>加入购物车后，根据您的数据不同，基本服务综合服务费也不同</span>
      </div>
      <div class="card-wrap_bottom">
        1.墓地综合服务费，5年一期，请按时交纳，也可到墓园营业厅办理；
        2.墓型不同，收费标准不同，请提交订单后联系墓园审核价格后才能进行支付；
        3.订单价格100只为部分墓型价格，请先提交订单，实缴价格审核后支付时会有显示。
        四墓园：0574-86530202，五墓园：0574-86530267，六墓园：0574-86506333，神钟山：0574-86520506；
      </div>
      <div style="margin:10px">
        <p v-html="detail.productDetails"></p>
      </div>

    </div>
    <van-goods-action>
      <van-goods-action-icon icon="cart-o" text="购物车" :badge="cartNum"
        @click="$router.push({ name: 'shoppingCartIndex' })" />
      <van-goods-action-button @click="addCart" type="warning" text="加入购物车" />
      <van-goods-action-button type="danger" text="立即购买" @click="handleShop" />
    </van-goods-action>
    <van-popup v-model="requiredServiceTimeObj.show" position="bottom">
      <van-datetime-picker v-model="requiredServiceTimeObj.time" type="datetime" title="选择预约时间" @confirm="confirm"
        @cancel="cancel" :formatter="formatter" />
    </van-popup>
  </div>
</template>

<script>
import { ImagePreview } from 'vant';
import { getInfo, getCountCart, commodityCart } from '@/api/good';
import { getStore, setStore, removeStore } from '@/utils/store';
import selectMuWei from '@/components/selectMuWei';

import { Toast } from 'vant';
import { deepClone } from '@/utils/util';
import moment from 'moment';
import 'moment/locale/zh-cn'; //moment 转中文 http://momentjs.cn/
export default {
  components: { selectMuWei },
  name: 'goodsDetail',
  data() {
    return {
      detail: {},
      form: {
        amount: 1,
        requiredServiceTime: new Date(
          moment()
            .add(7, 'day')
            .format('YYYY-MM-DD HH:mm:ss')
        ),
      },
      cartNum: 0,
      requiredServiceTimeObj: {
        show: false,
        time: '',
      },
    };
  },
  created() {
    this.getDetails();
    this.getCountCartFn();
    // console.log(this.$route.query)
  },
  // beforeRouteLeave(to, from, next) {
  //   console.log('detail',to, from)
  //   next(false);
  // },
  methods: {
    moment,
    formatter(type, value) {
      if (type === 'year') {
        return value + '年';
      } else if (type === 'month') {
        return value + '月';
      } else if (type === 'day') {
        return value + '日';
      } else if (type === 'hour') {
        return value + '时';
      } else if (type === 'minute') {
        return value + '分';
      } else if (type === 'second') {
        return value + '秒';
      }
      return value;
    },
    openTime() {
      this.requiredServiceTimeObj = {
        show: true,
        time: deepClone(this.form.requiredServiceTime),
      };
    },
    confirm(val) {
      this.$set(this.form, 'requiredServiceTime', val);
      this.cancel();
    },
    cancel() {
      this.requiredServiceTimeObj.show = false;
    },
    setData() {
      const mw = getStore({ name: 'mwActive' });
      return {
        amount: this.form.amount,
        commodityId: this.$route.query.id,
        tombLocationId: mw.graveBuyId,
        tombLocationName: mw.graveName,
        requiredServiceTime: moment(this.form.requiredServiceTime).format(
          'YYYY-MM-DD HH:mm:ss'
        ),
      };
    },
    addCart() {
      commodityCart(this.setData()).then(() => {
        Toast.success('添加购物车成功!');
        this.getCountCartFn();
      });
    },
    getCountCartFn() {
      getCountCart().then((res) => {
        this.cartNum = res.data;
      });
    },
    getDetails() {
      getInfo(this.$route.query.id).then((res) => {
        // console.log(res.data);
        this.detail = res.data;
        // 如果是绑定页过来的，直接跳到生成订单
        if (+getStore({ name: 'isToConfirm' }) === 1) {
          this.handleShop();
          removeStore({ name: 'isToConfirm' });
        }
      });
    },
    handleShop() {
      setStore({ name: 'shoppingForm', content: this.setData() });
      this.$router.push({
        name: 'orderConfirm',
        query: { ids: this.$route.query.id, type: 'commodity' },
      });
    },
    handlePreviewImg(index) {
      ImagePreview([this.detail.commodityRotationChart[index]]);
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  // overflow: hidden;
  padding-bottom: 86px;

  .card-wrap {
    background: #fff;
    padding: 10px 12px;
    box-sizing: border-box;

    .card-wrap_top {
      font-size: 14px;
      color: #909399;

      span {
        color: #ee0a24;
        font-weight: bold;
      }
    }

    .card-wrap_bottom {
      margin-top: 10px;
      padding: 10px 0;
      font-size: 12px;
      color: #909399;
      border-top: 1px solid #ebedf0;
      border-bottom: 1px solid #ebedf0;
    }
  }

  .van-hairline--top {
    display: flex;
    align-items: center;
    padding-top: 10px;

    span {
      margin-right: 10px;
    }
  }
}

.subtitle {
  position: relative;
  line-height: 30px;
  // background: #ebecf0;
  padding-left: 20px;
  box-sizing: border-box;
  margin: 0 0 12px;

  &::before {
    content: '';
    position: absolute;
    left: 5px;
    top: 50%;
    transform: translateY(-50%);
    width: 8px;
    height: 16px;
    background: #67c23a;
    border-radius: 2px;
  }
}

.goods-wrap {
  height: 150px;
  box-sizing: border-box;
  display: flex;
  padding-bottom: 10px;

  .goods-wrap_left {
    width: 150px;
    height: 100%;
    padding-right: 10px;
  }

  .goods-wrap_right {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    div:nth-child(1) {
      height: 25px;
      line-height: 25px;
      font-size: 16px;
      font-weight: bold;
      color: #303133;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    div:nth-child(2) {
      height: 35px;
      line-height: 35px;
      font-size: 20px;
      color: #ee0a24;
      font-weight: 900;
    }

    div:nth-child(3) {
      font-size: 14px;
      color: #ee0a24;
      overflow: hidden;
      text-overflow: ellipsis;
      flex: 1;
    }
  }
}

::v-deep .van-button--warning {
  border: none !important;
}
</style>
